/* 04.11.26: homepage product cards: click anywhere on the card (picture, name, price, text) to open the product page.
   The Add to Cart button and any other link or button inside the card keep working as normal.
   Swiping the carousel does not open the product. */
(function () {
  if (window.lbCardClick) return;
  window.lbCardClick = true;

  var css = '.lbh article.card{cursor:pointer}.lbh article.card:hover h3{text-decoration:underline;text-underline-offset:3px;text-decoration-thickness:1px}.lbh article.card button,.lbh article.card a{cursor:pointer}';
  var st = document.createElement('style');
  st.appendChild(document.createTextNode(css));
  document.head.appendChild(st);

  var startX = 0, startY = 0, moved = false;

  document.addEventListener('pointerdown', function (e) {
    startX = e.clientX; startY = e.clientY; moved = false;
  }, true);
  document.addEventListener('pointermove', function (e) {
    if (Math.abs(e.clientX - startX) > 8 || Math.abs(e.clientY - startY) > 8) moved = true;
  }, true);

  document.addEventListener('click', function (e) {
    if (moved || e.defaultPrevented) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.lbh article.card');
    if (!card) return;
    if (t.closest('a, button, input, select, textarea, label, [role="button"]')) return;
    var link = card.querySelector('a.pic[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.button === 1) {
      window.open(link.href, '_blank');
    } else {
      window.location.href = link.href;
    }
  });
})();
